export default "__VITE_ASSET__Nv2uSczx__"